import { useState, useEffect } from 'react';
import { ICandidateResumeResponse } from '../models/candidateProfile.model';
import { axiosCandidatesResume } from '../stateManagement/api';

const useCandidateResume = (candidateId: number | undefined) => {
  const [resumeDetailsData, setResumeDetailsData] =
    useState<ICandidateResumeResponse>();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      if (candidateId !== undefined) {
        try {
          setLoading(true);
          const response = await axiosCandidatesResume(candidateId);
          setResumeDetailsData(response);
          setError(null);
        } catch (apiError: any) {
          setError(apiError.message);
        } finally {
          setLoading(false);
        }
      } else {
        setLoading(true);
      }
    })();
  }, [candidateId]);

  return { resumeDetailsData, loading, error };
};

export default useCandidateResume;
